import { Dialog } from '@cw-ui/feedback-components';
import Button from '@mui/material/Button';
import Locale from 'src/i18n';
import { RadioGroup } from '@cw-ui/form-components';
import { formatMessage } from 'src/i18n/intl';
import { useState } from 'react';
import * as Styled from './ImportAllUsersModal.styles';

export const BULK_IMPORT_OPTIONS = {
    VISIBLE_ON_PAGE: 'VISIBLE_ON_PAGE',
    ALL: 'ALL',
};

export const ImportAllUsersModal = ({
    open,
    handleClose,
    handleContinue,
    totalUsersCount,
    pageSize,
    currentPageRecordsCount,
    isLoading = false,
}) => {
    const [selectedOption, setSelectedOption] = useState(BULK_IMPORT_OPTIONS.VISIBLE_ON_PAGE);

    const handleOptionChange = event => {
        setSelectedOption(event.target.value);
    };

    const options = [
        {
            label: formatMessage(Locale.importVisibleUsersOption, { currentPageRecordsCount }),
            value: BULK_IMPORT_OPTIONS.VISIBLE_ON_PAGE,
        },
        {
            label: formatMessage(Locale.importAllUsersOption, { totalUsersCount }),
            value: BULK_IMPORT_OPTIONS.ALL,
        },
    ];

    return (
        <Dialog
            open={open}
            data-testid="import-all-users-dialog"
            onClose={isLoading ? undefined : handleClose}
            aria-labelledby="import-all-users-dialog-title"
            aria-describedby="import-all-users-dialog-description">
            <Dialog.Title id="import-all-users-dialog-title">
                {formatMessage(Locale.importAllUsersDialogTitle)}
            </Dialog.Title>
            <Dialog.DialogContent id="import-all-users-dialog-description">
                <Styled.ModalHeaderText>{formatMessage(Locale.importModalHeaderText)}</Styled.ModalHeaderText>
                <Styled.StyledRadioGroup>
                    <RadioGroup
                        groupLabel="Import Option"
                        value={selectedOption}
                        onChange={handleOptionChange}
                        items={options}
                    />
                </Styled.StyledRadioGroup>
                <Styled.PageSummaryContainer>
                    {formatMessage(Locale.importModalPageSummary)}
                </Styled.PageSummaryContainer>
            </Dialog.DialogContent>
            <Dialog.DialogActions type="stepper">
                <Styled.DialogActionsContainer>
                    <Button
                        size="medium"
                        // variant="outlined"
                        color="secondary"
                        disabled={isLoading}
                        data-testid="cancel-button"
                        onClick={handleClose}>
                        {formatMessage(Locale.cancel)}
                    </Button>
                    <Button
                        size="medium"
                        variant="contained"
                        color="primary"
                        disabled={!selectedOption || isLoading}
                        data-testid="continue-button"
                        onClick={() => handleContinue(selectedOption)}>
                        {isLoading ? 'Processing...' : formatMessage(Locale.apply)}
                    </Button>
                </Styled.DialogActionsContainer>
            </Dialog.DialogActions>
        </Dialog>
    );
};
